import { Directive, input } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
} from '@angular/forms';
import { isNil } from '@lassi/util';

@Directive({
  selector: '[libDateFormatValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: DateFormatValidatorDirective,
      multi: true,
    },
  ],
})
export class DateFormatValidatorDirective implements Validator {
  required = input<boolean>(false);
  dayField = input.required<string>();
  monthField = input.required<string>();
  yearField = input.required<string>();

  validate(control: AbstractControl): ValidationErrors | null {
    const dayValue = control.value[this.dayField()];
    const monthValue = control.value[this.monthField()];
    const yearValue = control.value[this.yearField()];
    const isAllFieldsEmpty =
      isNil(dayValue) && isNil(monthValue) && isNil(yearValue);

    if (this.required() && isAllFieldsEmpty) {
      return { required: true };
    }

    // Validation for partial inputs - valid patterns are:
    // 1. Year only
    // 2. Month + Year
    // 3. Day + Month + Year
    // 4. All empty
    if (
      // Day without month or year
      (!isNil(dayValue) && (isNil(monthValue) || isNil(yearValue))) ||
      // Month without year
      (!isNil(monthValue) && isNil(yearValue))
    ) {
      return { invalidDateFormat: true };
    }

    return null;
  }
}
